import React from 'react';
import { classNames, numFormat } from '../../Services/helpers';

const Money = ({pence, colour, className, symbol = true, hidePence = false}) => {

    const _pence = pence ?? 0;

    // const penceStr = hidePence ? '' : '.'+(pence % 100).toString().padStart(2, '0');
    const val = <>{symbol && <>&pound;</>} {numFormat(_pence/100, hidePence)}</>;

    if (!colour) {
        return <span className={className}>{val}</span>;
    }

    if (_pence > 0) {
        return <span className={classNames('text-green-500', className)}>{val}</span>
    } else if (_pence < 0) {
        return <span className={classNames('text-red-500', className)}>{val}</span>
    } else {
        return <span className={classNames('text-gray-500', className)}>{val}</span>
    }
}

export default Money;
